import { render, staticRenderFns } from "./CommentPop.vue?vue&type=template&id=44216cf7&scoped=true&"
import script from "./CommentPop.vue?vue&type=script&lang=js&"
export * from "./CommentPop.vue?vue&type=script&lang=js&"
import style0 from "./CommentPop.vue?vue&type=style&index=0&id=44216cf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44216cf7",
  null
  
)

export default component.exports